<template>
    <div>
        <div v-if="this.$store.state.device.isMobile">
            <navbarTop></navbarTop>
            <navbarBottom></navbarBottom>
            <div style="position: relative">
                <b-form style="padding-top: 80px">
                    <b-row class="progress_row">
                        <b-col cols="2" class="progress_col"><span class="dot_active" :style="{'border': '3px solid'+this.$store.state.device.color, 'background-color':this.$store.state.device.color }"><span class="number_progression_active"><b>1</b></span></span></b-col>
                        <b-col cols="3" class="progress_col"><hr class="hr" :style="{'background-color': this.$store.state.device.color}"></b-col>
                        <b-col cols="2" class="progress_col"><span class="dot_active" :style="{'border': '3px solid'+this.$store.state.device.color, 'background-color':this.$store.state.device.color }"><span class="number_progression_active"><b>2</b></span></span></b-col>
                        <b-col cols="3" class="progress_col"><hr class="hr" :style="{'background-color': this.$store.state.device.color}"></b-col>
                        <b-col cols="2" class="progress_col"><span class="dot_active" :style="{'border': '3px solid'+this.$store.state.device.color, 'background-color':this.$store.state.device.color }"><span class="number_progression_active"><b>3</b></span></span></b-col>
                    </b-row>
                    <div style="width: 80%;margin: 10% auto 20%;">
                        <div style="text-align: left;">
                            <b>{{ $t('pages.Registration.RegistrationSummary') }}</b>
                        </div>
                        <br>
                        <div style="text-align: left;">
                            <b>{{ $t('pages.Registration.Name') }}</b>
                        </div>
                        <div style="text-align: left;">
                            {{this.$store.state.createSocio.name}}
                        </div>
                        <br>
                        <div style="text-align: left;">
                            <b>{{ $t('pages.Registration.Email') }}</b>
                        </div>
                        <div style="text-align: left;">
                            {{this.$store.state.createSocio.email}}
                        </div>
                        <br>
                        <div style="text-align: left;">
                            <b>{{ $t('pages.Registration.Phone') }}</b>
                        </div>
                        <div style="text-align: left;">
                            {{this.$store.state.createSocio.phone_number}}
                        </div>
                        <br>
                        <div style="text-align: left;">
                            <b>{{ $t('pages.Registration.Location') }}</b>
                        </div>
                        <div style="text-align: left;">
                            {{this.$store.state.createSocio.address}}
                        </div>
                        <br>
                        <div style="text-align: left;">
                            <b>{{ $t('pages.Registration.BirthdayDate') }}</b>
                        </div>
                        <div style="text-align: left;">
                            {{this.$store.state.createSocio.birthday_date}}
                        </div>
                        <br>
                        <div style="text-align: left;">
                            <b>{{ $t('pages.Registration.MemberType') }}</b>
                        </div>
                        <div style="text-align: left;" v-if="this.$store.state.createSocio.type==1">Normal</div>
                        <div style="text-align: left;" v-if="this.$store.state.createSocio.type==2">Idoso</div>
                        <div style="text-align: left;" v-if="this.$store.state.createSocio.type==3">Criança</div>
                        <div style="text-align: left;" v-if="this.$store.state.createSocio.type==4">Atleta</div>
                        <div style="text-align: left;" v-if="this.$store.state.createSocio.type==5">Mulher</div>
                        <hr v-if="!this.$store.state.createSocio.number_of_payments_year == 0">
                        <div v-if="!this.$store.state.createSocio.number_of_payments_year == 0" style="text-align: left; color: #209428;">
                            <b>{{ $t('pages.Registration.Payed') }}</b>
                        </div>
                        <br v-if="!this.$store.state.createSocio.number_of_payments_year == 0">

                        <!--NORMAL-->
                        <div v-if="this.$store.state.createSocio.type == 1">
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 1" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalMonth') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_default}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 3" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalTrimester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_default}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 6" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalSemester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_default}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 12" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalYear') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_default}}€</b></label></div>
                        </div>

                        <!--IDOSO-->
                        <div v-if="this.$store.state.createSocio.type == 2">
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 1" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalMonth') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_elderly}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 3" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalTrimester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_elderly}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 6" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalSemester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_elderly}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 12" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalYear') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_elderly}}€</b></label></div>
                        </div>

                        <!--CRIANÇA-->
                        <div v-if="this.$store.state.createSocio.type == 3">
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 1" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalMonth') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_child}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 3" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalTrimester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_child}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 6" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalSemester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_child}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 12" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalYear') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_child}}€</b></label></div>
                        </div>

                        <!--ATLETA-->
                        <div v-if="this.$store.state.createSocio.type == 4">
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 1" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalMonth') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_athlete}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 3" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalTrimester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_athlete}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 6" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalSemester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_athlete}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 12" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalYear') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_athlete}}€</b></label></div>
                        </div>

                        <!--MULHER-->
                        <div v-if="this.$store.state.createSocio.type == 5">
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 1" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalMonth') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_woman}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 3" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalTrimester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_woman}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 6" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalSemester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_woman}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 12" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalYear') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_woman}}€</b></label></div>
                        </div>

                        <br v-if="!this.$store.state.createSocio.number_of_payments_year == 0">
                        <br v-if="!this.$store.state.createSocio.number_of_payments_year == 0">

                        <div style="text-align: left;margin-top: 5%;">
                            <a v-on:click="back"><i style="margin-right: 10px; margin-left: 0;" class="fas fa-chevron-left"></i>{{ $t('standard.back') }}</a>
                        </div>

                        <b-button id="btnCreate" v-on:click="seguinte">
                            {{ $t('pages.Registration.SubmitButton') }}
                             <i style="padding-left: 10px;" class="fas fa-user-plus"></i>
                        </b-button>

                        <b-modal id="modal" scrollable centered no-stacking hide-footer hide-header>
                            <b-row><b-button class="modal_terms_buttons" v-b-modal.modal_presencial>Registo Presencial</b-button></b-row>
                            <hr class="modal_terms_hr">
                            <b-row><b-button class="modal_terms_buttons" v-b-modal.modal_upload>Upload Formulário</b-button></b-row>
                        </b-modal>

                        <b-modal id="modal_presencial" scrollable centered no-stacking>
                            <div class="container" style="padding: 0;">
                                <div class="terms">
                                    <h4 style="text-align: center"><b>Termos de Consentimento</b></h4>
                                    <br>
                                    <p><b>{{organization}}</b> utiliza os seus dados de forma transparente, por isso, enquanto sócio desta instituição e titular dos seus dados e de acordo com o Artigo 6º, ponto 1, alínea a) do Regulamento Geral de Proteção de Dados (Regulamento UE n.º 679/2016 de 27 de abril),  solicitamos o seu consentimento informado tendo por base as seguintes informações sobre o tratamento dos dados:</p>
                                    <br>
                                    <h5><b>Informações Gerais</b></h5>
                                    <ul>
                                        <li><i class="fas fa-chevron-right"></i>Responsável pelo tratamento de dados: {{organization}}</li>
                                        <li><i class="fas fa-chevron-right"></i>Subcontratado responsável pela base de dados e encriptação dos dados: IOTECHPIS- Innovation on Technology, Lda.</li>
                                    </ul>
                                    <p>O tratamento de dados pessoais representa qualquer operação efetuada (recolha, registo, alteração, consulta, utilização, transmissão e destruição), por meio automatizado e/ou não automatizado sobre os dados abaixo identificados. </p>
                                    <br>
                                    <h5><b>Tipo de dados que podemos recolher e armazenar</b></h5>
                                    <ul>
                                        <li>
                                            Informações fornecidas por si, enquanto sócio, durante o preenchimento da ficha de sócio. As informações sujeitas a recolha e consentimento informado são:
                                            <ul>
                                                <li><i class="fas fa-chevron-right"></i>Nome;</li>
                                                <li><i class="fas fa-chevron-right"></i>Endereço Correio Eletrónico;</li>
                                                <li><i class="fas fa-chevron-right"></i>Morada;</li>
                                                <li><i class="fas fa-chevron-right"></i>Contacto Telefónico;</li>
                                                <li><i class="fas fa-chevron-right"></i>Data de Nascimento;</li>
                                                <li><i class="fas fa-chevron-right"></i>Perfil de Sócio;</li>
                                                <li><i class="fas fa-chevron-right"></i>Informações sobre pagamento de cotas;</li>
                                                <li><i class="fas fa-chevron-right"></i>Assinatura.</li>
                                            </ul>
                                        </li>
                                        <li><i class="fas fa-chevron-right"></i>Todos os estão são guardados de forma encriptada nas bases de dados do subcontratado responsável pelas mesmas;</li>
                                        <li><i class="fas fa-chevron-right"></i>O responsável pelo tratamento de dados cumpre as obrigações legais aplicáveis e observa os princípios e regras de tratamento identificadas no Regulamento Geral de Proteção de Dados.</li>
                                    </ul>
                                    <br>
                                    <h5><b>Fins para os quais os dados estão a ser tratados</b></h5>
                                    <ul>
                                        <li><i class="fas fa-chevron-right"></i>Permitir o registo do sócio;</li>
                                        <li><i class="fas fa-chevron-right"></i>Permitir o registo e consulta de pagamento de cotas;</li>
                                        <li><i class="fas fa-chevron-right"></i>Assegurar uma comunicação interna correta com o sócio como por exemplo através do envio de e-mails e/ou mensagens;</li>
                                        <li><i class="fas fa-chevron-right"></i>Cumprir com as nossas obrigações decorrentes deste termo de consentimento.</li>
                                    </ul>
                                    <br>
                                    <h5><b>Local de armazenamento dos dados</b></h5>
                                    <ul>
                                        <li><i class="fas fa-chevron-right"></i>Os dados que recolhemos de si podem ser transferidos e armazenados em vários destinos, dentro da união europeia, de acordo com os locais da nuvem(cloud). Ao enviar os seus dados pessoais, você concorda com esta transferência, armazenamento ou processamento. Tomaremos todas as medidas razoavelmente necessárias para garantir que os seus dados sejam tratados com segurança e de acordo com as nossas políticas de privacidade.</li>
                                        <li><i class="fas fa-chevron-right"></i>Todas as informações que o utilizador nos fornece são armazenadas de forma segura por nós, no entanto, a transmissão de informações pela internet não é totalmente segura embora os nossos serviços estejam assentes em protocolos seguros (SSL/TLS). Nós fazemos o nosso melhor para proteger os seus dados pessoais, no entanto, não podemos garantir a segurança dos dados por si transmitidos. Qualquer transmissão externa é da sua responsabilidade. Assim que recebermos as suas informações, usaremos procedimentos rigorosos e recursos de segurança para tentar impedir o acesso não autorizado.</li>
                                    </ul>
                                    <br>
                                    <h5><b>Direitos dos titulares de dados pessoais:</b></h5>
                                    <ul>
                                        <li><i class="fas fa-chevron-right"></i><b>Direito ao acesso -</b> prestação de informação acerca dos dados pessoais guardados por parte da entidade responsável pelo tratamento de dados;</li>
                                        <li><i class="fas fa-chevron-right"></i><b>Direito à retificação -</b> correção, atualização ou inclusão de dados relativos ao titular dos mesmos;</li>
                                        <li><i class="fas fa-chevron-right"></i><b>Direito ao apagamento de dados -</b> apagamento dos dados, verificados os requisitos legais e de negócio para o efeito (por exemplo: inexistência de dívidas por parte do titular dos dados para com a instituição responsável pelo tratamento de dados);</li>
                                        <li><i class="fas fa-chevron-right"></i><b>Direito à limitação do tratamento -</b> suspensão/cessação do tratamento dos dados, salvaguardando o facto de que tal poderá limitar a condição de sócio e os respetivos direitos de associado;</li>
                                        <li><i class="fas fa-chevron-right"></i><b>Direito à Portabilidade -</b> disponibilização dos dados pessoais facultados pelo sócio, em formato estruturado de uso corrente e de leitura automática, de modo a que possam ser transmitidos a outro responsável pelo tratamento;</li>
                                        <li><i class="fas fa-chevron-right"></i><b>Direito à oposição -</b> revogação do consentimento informado para o tratamento dos dados recolhidos efetuado com base nesse fundamento, verificados os requisitos legais e de negócio para o efeito (por exemplo: inexistência de dívidas por parte do titular dos dados para com a instituição responsável pelo tratamento de dados e salvaguardando o facto de que tal poderá limitar a condição de sócio e os respetivos direitos de associado).</li>
                                    </ul>
                                    <p>Para exercer qualquer um dos seus direitos, o titular dos dados poderá, a qualquer momento, efetuar o pedido através do envio de um e-mail para geral@iotech.pt . </p>
                                    <b-form-checkbox
                                            v-model="terms_accepted"
                                            value=1
                                            unchecked-value=0
                                    >
                                        Autorizo o tratamento dos meus dados pessoais pela IOTECH nos termos da lei em vigor.
                                    </b-form-checkbox>
                                </div>
                                <VueSignaturePad
                                        id="signature"
                                        width="100%"
                                        height="10vh"
                                        ref="signaturePad"
                                        :options="{penColor: '#000000', onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
                                        style="margin-top: 5%"
                                />
                                <div style="text-align: left; margin-top: 5%;">
                                    <button class="btn btn-outline-secondary" @click="undo">Undo</button>
                                </div>
                            </div>
                            <div slot="modal-footer" class="modal-footer">
                                <b-button class="btn btn-default" @click="closeModal('modal_presencial')">Cancel</b-button>
                                <b-button :style="'background-color: '+this.$store.state.device.color+';border-color: '+this.$store.state.device.color" :disabled="terms_accepted==0 " @click="registar">Registar</b-button>
                            </div>
                        </b-modal>

                        <b-modal id="modal_upload" scrollable centered no-stacking>
                            <div>
                                <b-form-file
                                        v-model="file"
                                        :state="Boolean(file)"
                                        accept="image/*"
                                        :capture=true
                                        placeholder="Choose a file or drop it here..."
                                        drop-placeholder="Drop file here..."
                                ></b-form-file>
                            </div>
                            <div slot="modal-footer" class="modal-footer">
                                <b-button class="btn btn-default" @click="closeModal('modal_upload')">Cancel</b-button>
                                <b-button :style="'background-color: '+this.$store.state.device.color+';border-color: '+this.$store.state.device.color" :disabled="file==undefined" @click="registar">Registar</b-button>
                            </div>
                        </b-modal>

                    </div>
                </b-form>
            </div>
        </div>
        <div v-if="this.$store.state.device.isDesktop">
            <navbarTop></navbarTop>
            <sideBar></sideBar>
            <div class="desktop_container">
                <div style="padding: 16px;">
                    <b-form>
                        <h5 style="text-align: left"><b>{{ $t('pages.Registration.RegistrationSummary') }}</b></h5>
                        <hr style="background-color: #8D99AE; border: 1px solid #8D99AE">
                        <br>

                        <b-row>
                            <b-col>
                                <div style="text-align: left;">
                                    <b>{{ $t('pages.Registration.Name') }}</b>
                                </div>
                                <div style="text-align: left;">
                                    {{this.$store.state.createSocio.name}}
                                </div>
                            </b-col>
                            <b-col>
                                <div style="text-align: left;">
                                    <b>{{ $t('pages.Registration.Email') }}</b>
                                </div>
                                <div style="text-align: left;">
                                    {{this.$store.state.createSocio.email}}
                                </div>
                            </b-col>
                        </b-row>
                        <br>
                        <b-row>
                            <b-col>
                                <div style="text-align: left;">
                                    <b>{{ $t('pages.Registration.Location') }}</b>
                                </div>
                                <div style="text-align: left;">
                                    {{this.$store.state.createSocio.address}}
                                </div>
                            </b-col>
                            <b-col>
                                <div style="text-align: left;">
                                    <b>{{ $t('pages.Registration.BirthdayDate') }}</b>
                                </div>
                                <div style="text-align: left;">
                                    {{this.$store.state.createSocio.birthday_date}}
                                </div>
                            </b-col>
                        </b-row>
                        <br>
                        <b-row>
                            <b-col>
                                <div style="text-align: left;">
                                    <b>{{ $t('pages.Registration.Phone') }}</b>
                                </div>
                                <div style="text-align: left;">
                                    {{this.$store.state.createSocio.phone_number}}
                                </div>
                            </b-col>
                            <b-col>
                                <div style="text-align: left;">
                                    <b>{{ $t('pages.Registration.MemberType') }}</b>
                                </div>
                                <div style="text-align: left;" v-if="this.$store.state.createSocio.type==1">Normal</div>
                                <div style="text-align: left;" v-if="this.$store.state.createSocio.type==2">Idoso</div>
                                <div style="text-align: left;" v-if="this.$store.state.createSocio.type==3">Criança</div>
                                <div style="text-align: left;" v-if="this.$store.state.createSocio.type==4">Atleta</div>
                                <div style="text-align: left;" v-if="this.$store.state.createSocio.type==5">Mulher</div>
                            </b-col>
                        </b-row>

                        <br>
                        <br v-if="!this.$store.state.createSocio.number_of_payments_year == 0">
                        <div v-if="!this.$store.state.createSocio.number_of_payments_year == 0" style="text-align: left; color: #209428;">
                            <b>{{ $t('pages.Registration.Payed') }}</b>
                        </div>
                        <br v-if="!this.$store.state.createSocio.number_of_payments_year == 0">

                        <!--NORMAL-->
                        <div v-if="this.$store.state.createSocio.type == 1">
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 1" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalMonth') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_default}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 3" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalTrimester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_default}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 6" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalSemester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_default}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 12" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalYear') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_default}}€</b></label></div>
                        </div>

                        <!--IDOSO-->
                        <div v-if="this.$store.state.createSocio.type == 2">
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 1" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalMonth') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_elderly}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 3" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalTrimester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_elderly}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 6" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalSemester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_elderly}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 12" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalYear') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_elderly}}€</b></label></div>
                        </div>

                        <!--CRIANÇA-->
                        <div v-if="this.$store.state.createSocio.type == 3">
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 1" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalMonth') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_child}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 3" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalTrimester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_child}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 6" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalSemester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_child}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 12" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalYear') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_child}}€</b></label></div>
                        </div>

                        <!--ATLETA-->
                        <div v-if="this.$store.state.createSocio.type == 4">
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 1" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalMonth') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_athlete}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 3" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalTrimester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_athlete}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 6" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalSemester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_athlete}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 12" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalYear') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_athlete}}€</b></label></div>
                        </div>

                        <!--MULHER-->
                        <div v-if="this.$store.state.createSocio.type == 5">
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 1" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalMonth') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_woman}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 3" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalTrimester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_woman}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 6" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalSemester') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_woman}}€</b></label></div>
                            <div v-if="this.$store.state.createSocio.number_of_payments_year == 12" style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.TotalYear') }}</b><b style="color: #209428;">{{this.$store.state.createSocio.number_of_payments_year * value_woman}}€</b></label></div>
                        </div>

                        <br v-if="!this.$store.state.createSocio.number_of_payments_year == 0">
                        <br v-if="!this.$store.state.createSocio.number_of_payments_year == 0">


                        <div class="footer_desktop">
                            <hr class="bottom_line">
                            <div class="footer_content_right">
                                <a v-on:click="back_desktop" style="text-decoration: underline;">{{ $t('standard.back') }}</a>
                                <b-button id="createDesktop" v-on:click="seguinte">
                                    {{ $t('pages.Registration.SubmitButton') }}
                                    <i class="fas fa-user-plus" style="margin-left: 5px;"></i>
                                </b-button>
                            </div>
                        </div>

                        <b-modal id="modal" scrollable centered no-stacking hide-footer hide-header>
                            <b-row><b-button class="modal_terms_buttons" v-b-modal.modal_presencial>Registo Presencial</b-button></b-row>
                            <hr class="modal_terms_hr">
                            <b-row><b-button class="modal_terms_buttons" v-b-modal.modal_upload>Upload Formulário</b-button></b-row>
                        </b-modal>

                        <b-modal id="modal_presencial" scrollable centered no-stacking>
                            <div class="container" style="padding: 0;">
                                <div class="terms">
                                    <h4 style="text-align: center"><b>Termos de Consentimento</b></h4>
                                    <br>
                                    <p><b>{{organization}}</b> utiliza os seus dados de forma transparente, por isso, enquanto sócio desta instituição e titular dos seus dados e de acordo com o Artigo 6º, ponto 1, alínea a) do Regulamento Geral de Proteção de Dados (Regulamento UE n.º 679/2016 de 27 de abril),  solicitamos o seu consentimento informado tendo por base as seguintes informações sobre o tratamento dos dados:</p>
                                    <br>
                                    <h5><b>Informações Gerais</b></h5>
                                    <ul>
                                        <li><i class="fas fa-chevron-right"></i>Responsável pelo tratamento de dados: {{organization}}</li>
                                        <li><i class="fas fa-chevron-right"></i>Subcontratado responsável pela base de dados e encriptação dos dados: IOTECHPIS- Innovation on Technology, Lda.</li>
                                    </ul>
                                    <p>O tratamento de dados pessoais representa qualquer operação efetuada (recolha, registo, alteração, consulta, utilização, transmissão e destruição), por meio automatizado e/ou não automatizado sobre os dados abaixo identificados. </p>
                                    <br>
                                    <h5><b>Tipo de dados que podemos recolher e armazenar</b></h5>
                                    <ul>
                                        <li>
                                            Informações fornecidas por si, enquanto sócio, durante o preenchimento da ficha de sócio. As informações sujeitas a recolha e consentimento informado são:
                                            <ul>
                                                <li><i class="fas fa-chevron-right"></i>Nome;</li>
                                                <li><i class="fas fa-chevron-right"></i>Endereço Correio Eletrónico;</li>
                                                <li><i class="fas fa-chevron-right"></i>Morada;</li>
                                                <li><i class="fas fa-chevron-right"></i>Contacto Telefónico;</li>
                                                <li><i class="fas fa-chevron-right"></i>Data de Nascimento;</li>
                                                <li><i class="fas fa-chevron-right"></i>Perfil de Sócio;</li>
                                                <li><i class="fas fa-chevron-right"></i>Informações sobre pagamento de cotas;</li>
                                                <li><i class="fas fa-chevron-right"></i>Assinatura.</li>
                                            </ul>
                                        </li>
                                        <li><i class="fas fa-chevron-right"></i>Todos os estão são guardados de forma encriptada nas bases de dados do subcontratado responsável pelas mesmas;</li>
                                        <li><i class="fas fa-chevron-right"></i>O responsável pelo tratamento de dados cumpre as obrigações legais aplicáveis e observa os princípios e regras de tratamento identificadas no Regulamento Geral de Proteção de Dados.</li>
                                    </ul>
                                    <br>
                                    <h5><b>Fins para os quais os dados estão a ser tratados</b></h5>
                                    <ul>
                                        <li><i class="fas fa-chevron-right"></i>Permitir o registo do sócio;</li>
                                        <li><i class="fas fa-chevron-right"></i>Permitir o registo e consulta de pagamento de cotas;</li>
                                        <li><i class="fas fa-chevron-right"></i>Assegurar uma comunicação interna correta com o sócio como por exemplo através do envio de e-mails e/ou mensagens;</li>
                                        <li><i class="fas fa-chevron-right"></i>Cumprir com as nossas obrigações decorrentes deste termo de consentimento.</li>
                                    </ul>
                                    <br>
                                    <h5><b>Local de armazenamento dos dados</b></h5>
                                    <ul>
                                        <li><i class="fas fa-chevron-right"></i>Os dados que recolhemos de si podem ser transferidos e armazenados em vários destinos, dentro da união europeia, de acordo com os locais da nuvem(cloud). Ao enviar os seus dados pessoais, você concorda com esta transferência, armazenamento ou processamento. Tomaremos todas as medidas razoavelmente necessárias para garantir que os seus dados sejam tratados com segurança e de acordo com as nossas políticas de privacidade.</li>
                                        <li><i class="fas fa-chevron-right"></i>Todas as informações que o utilizador nos fornece são armazenadas de forma segura por nós, no entanto, a transmissão de informações pela internet não é totalmente segura embora os nossos serviços estejam assentes em protocolos seguros (SSL/TLS). Nós fazemos o nosso melhor para proteger os seus dados pessoais, no entanto, não podemos garantir a segurança dos dados por si transmitidos. Qualquer transmissão externa é da sua responsabilidade. Assim que recebermos as suas informações, usaremos procedimentos rigorosos e recursos de segurança para tentar impedir o acesso não autorizado.</li>
                                    </ul>
                                    <br>
                                    <h5><b>Direitos dos titulares de dados pessoais:</b></h5>
                                    <ul>
                                        <li><i class="fas fa-chevron-right"></i><b>Direito ao acesso -</b> prestação de informação acerca dos dados pessoais guardados por parte da entidade responsável pelo tratamento de dados;</li>
                                        <li><i class="fas fa-chevron-right"></i><b>Direito à retificação -</b> correção, atualização ou inclusão de dados relativos ao titular dos mesmos;</li>
                                        <li><i class="fas fa-chevron-right"></i><b>Direito ao apagamento de dados -</b> apagamento dos dados, verificados os requisitos legais e de negócio para o efeito (por exemplo: inexistência de dívidas por parte do titular dos dados para com a instituição responsável pelo tratamento de dados);</li>
                                        <li><i class="fas fa-chevron-right"></i><b>Direito à limitação do tratamento -</b> suspensão/cessação do tratamento dos dados, salvaguardando o facto de que tal poderá limitar a condição de sócio e os respetivos direitos de associado;</li>
                                        <li><i class="fas fa-chevron-right"></i><b>Direito à Portabilidade -</b> disponibilização dos dados pessoais facultados pelo sócio, em formato estruturado de uso corrente e de leitura automática, de modo a que possam ser transmitidos a outro responsável pelo tratamento;</li>
                                        <li><i class="fas fa-chevron-right"></i><b>Direito à oposição -</b> revogação do consentimento informado para o tratamento dos dados recolhidos efetuado com base nesse fundamento, verificados os requisitos legais e de negócio para o efeito (por exemplo: inexistência de dívidas por parte do titular dos dados para com a instituição responsável pelo tratamento de dados e salvaguardando o facto de que tal poderá limitar a condição de sócio e os respetivos direitos de associado).</li>
                                    </ul>
                                    <p>Para exercer qualquer um dos seus direitos, o titular dos dados poderá, a qualquer momento, efetuar o pedido através do envio de um e-mail para geral@iotech.pt . </p>
                                    <b-form-checkbox
                                            v-model="terms_accepted"
                                            value=1
                                            unchecked-value=0
                                    >
                                        Autorizo o tratamento dos meus dados pessoais pela IOTECH nos termos da lei em vigor.
                                    </b-form-checkbox>
                                </div>
                                <VueSignaturePad
                                        id="signature"
                                        width="100%"
                                        height="10vh"
                                        ref="signaturePad"
                                        :options="{penColor: '#000000', onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
                                        style="margin-top: 5%"
                                />
                                <div style="text-align: left; margin-top: 5%;">
                                    <button class="btn btn-outline-secondary" @click="undo">Undo</button>
                                </div>
                            </div>
                            <div slot="modal-footer">
                                <b-button class="btn btn-default" @click="closeModal('modal_presencial')" style="margin-right: 10px;">Cancel</b-button>
                                <b-button :style="'background-color: '+this.$store.state.device.color+';border-color: '+this.$store.state.device.color" :disabled="terms_accepted==0 " @click="registar">Registar</b-button>
                            </div>
                        </b-modal>

                        <b-modal id="modal_upload" scrollable centered no-stacking>
                            <div>
                                <b-form-file
                                        v-model="file"
                                        :state="Boolean(file)"
                                        accept="image/*"
                                        :capture=true
                                        placeholder="Choose a file or drop it here..."
                                        drop-placeholder="Drop file here..."
                                ></b-form-file>
                            </div>
                            <div slot="modal-footer">
                                <b-button class="btn btn-default" @click="closeModal('modal_upload')" style="margin-right: 10px;">Cancel</b-button>
                                <b-button :style="'background-color: '+this.$store.state.device.color+';border-color: '+this.$store.state.device.color" :disabled="file==undefined" @click="registar">Registar</b-button>
                            </div>
                        </b-modal>

                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import NavbarTop from "../components/navbarTop";
    import navbarBottom from "../components/navbarBottom";
    import VuePhoneNumberInput from "vue-phone-number-input";
    import sideBar from "../components/sideBar";
    import { BModal } from 'bootstrap-vue'
    import {newMember} from "../api/Member/apiMember";
    import BCheckbox from "buefy/src/components/checkbox/Checkbox";
    import BRadio from "buefy/src/components/radio/Radio";
    export default {
        name: "Registar",
        data() {
            return {
                file: null,
                terms_accepted: 1,
                value_default: null,
                value_elderly: null,
                value_child: null,
                value_athlete: null,
                value_woman: null,
                organization: localStorage.getItem('organization'),
                autocompleteOptions: {
                    componentRestrictions: {
                        country: [
                            'pt',
                        ],
                    },
                },
                true: true
            };
        },
        components: {BRadio, BCheckbox, NavbarTop, navbarBottom, sideBar, VuePhoneNumberInput, BModal},
        methods: {
            undo() {
                this.$refs.signaturePad.undoSignature();
            },
            back() {
                this.$router.push('/createSocio2');
            },
            back_desktop() {
                this.$router.push('/createSocio');
            },
            seguinte () {
                this.$bvModal.show("modal");
                this.file=null;
                this.terms_accepted=0;
            },
            createMemberLocalstorage(member_data) {
                let members = JSON.parse(localStorage.getItem('members'));
                let last_number = members.slice(-1)[0].number;
                member_data.number = parseInt(last_number) + 1;
                member_data.notes = null;
                member_data.active = 1;
                member_data.created = new Date().toISOString();
                member_data.email = member_data.member_email;
                member_data.send_alert_email = 0;
                //Calculate status
                let month = new Date().getMonth()+1;
                if(member_data.number_of_payments_year >= month) member_data.status = 1;
                else member_data.status = 2;
                members.push(member_data);
                localStorage.setItem('members', JSON.stringify(members));
            },
            registar() {
                let spinner = this.$loading.open();
                let member_data = {};
                let state = this.$store.state.createSocio;
                let value = null;
                if(state.type==1) value=this.value_default;
                if(state.type==2) value=this.value_elderly;
                if(state.type==3) value=this.value_child;
                if(state.type==4) value=this.value_athlete;
                if(state.type==5) value=this.value_woman;
                if(this.file!=null) {
                    let toast = this.$toast;
                    let router = this.$router;
                    let reader = new FileReader();
                    reader.readAsDataURL(this.file);
                    reader.onload = function () {
                        member_data = {
                            name: state.name,
                            birthday_date: state.birthday_date,
                            member_email: state.email,
                            phone_number: state.phone_number,
                            address: state.address,
                            number_of_payments_year: state.number_of_payments_year,
                            type: state.type,
                            value: value * state.number_of_payments_year,
                            signature: reader.result
                        };
                        newMember(member_data)
                            .then(response => {
                                this.createMemberLocalstorage(member_data);
                                spinner.close();
                                toast.open('Sócio registado');
                                router.push('/listSocios');
                            })
                            .catch(error => {
                                spinner.close();
                                if (!error.response) toast.open({message: "O ficheiro é demasiado grande", type: 'is-danger'});
                                else{
                                    let response_error = error.response.data;
                                    router.push('/createSocio');
                                    toast.open({message: response_error[Object.keys(response_error)[0]].msg.code, type: 'is-danger'});
                                }
                            });
                    };
                }else {
                    const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                    if((isEmpty==true) || (this.terms_accepted==0)) {
                        this.$toast.open({message: "Por favor aceite os termos e assine no local respetivo", type: 'is-danger', duration: 3000});
                    }else{
                        member_data = {
                            name: this.$store.state.createSocio.name,
                            birthday_date: this.$store.state.createSocio.birthday_date,
                            member_email: this.$store.state.createSocio.email,
                            phone_number: this.$store.state.createSocio.phone_number,
                            address: this.$store.state.createSocio.address,
                            number_of_payments_year: this.$store.state.createSocio.number_of_payments_year,
                            type: this.$store.state.createSocio.type,
                            value: value * this.$store.state.createSocio.number_of_payments_year,
                            signature: data
                        };
                        newMember(member_data)
                            .then(response => {
                                this.createMemberLocalstorage(member_data);
                                spinner.close();
                                this.$toast.open('Sócio registado');
                                this.$router.push('/listSocios');
                            })
                            .catch(error => {
                                spinner.close();
                                if (!error.response) this.$toast.open({message: "Algo não correu bem...", type: 'is-danger'});
                                else{
                                    let response_error = error.response.data;
                                    this.$router.push('/createSocio');
                                    this.$toast.open({message: response_error[Object.keys(response_error)[0]].msg.code, type: 'is-danger'});
                                }
                            });
                    }
                }
            },
            closeModal (id) {
                this.$bvModal.hide(id);
            }
        },
        mounted() {
            let spinner = this.$loading.open();
            this.$store.state.createSocio.values.then(response => {
                this.value_default = response.fee_value_default;
                this.value_elderly = response.fee_value_elderly;
                this.value_child = response.fee_value_child;
                this.value_athlete = response.fee_value_athlete;
                this.value_woman = response.fee_value_woman;
                spinner.close();
            });
        }
    };
</script>

<style scoped>
    .modal-footer {
        border: 0 !important;
    }
    .progress_row {
        width: 80%;
        margin: auto;
    }
    .progress_col {
        padding: 0;
    }
    #btnCreate {
        width: 40%;
        background: #2B2D42 0% 0% no-repeat padding-box;
        border-radius: 32px;
        color: white;
        border: none;
        letter-spacing: 0.85px;
        text-align: center;
        position: fixed;
        bottom: 68px;
        right: 10px;
    }
    @media (max-width: 330px) {
        .label_register {
            width: 100%;
            height: 100%;
            margin: auto;
            padding-top: 6%
        }
        .hr {
            border: none;
            height: 3px;
            position: relative;
            margin: 30% auto auto;
        }
    }
    @media (min-width: 330px) {
        .label_register {
            width: 100%;
            height: 100%;
            margin: auto;
            padding-top: 10%
        }
        .hr {
            border: none;
            height: 3px;
            position: relative;
            margin: 25% auto auto;
        }
    }
    input {
        background: white;
        border-radius: 32px;
        height: 47px;
    }
    legend {
        color: #2B2D42;
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.8px;
        margin-bottom: 2%;
    }
    .dot_active {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        display: flex;
    }

    .number_progression_active {
        color: white;
        margin: 10%;
        font-size: 20px;
        padding-left: 25%;
    }
    /*TERMS*/
    .terms {
        margin-top: 5%;
        text-align: justify;
        text-justify: inter-word;
    }
    /*SIGNATURE*/
    #signature {
        border: double 3px transparent;
        border-radius: 5px;
        background-image: linear-gradient(white, white),
        radial-gradient(circle at top left, #000000, #2B2D42);
        background-origin: border-box;
        background-clip: content-box, border-box;
    }
    /*MODAL*/
    @media (max-width: 325px) {
        .modal_terms_buttons {
            margin: auto;
            width: 90%;
            height: 100%;
            font-size: 125%;
            letter-spacing: 1px;
            background-color: #2B2D42;
            margin: 5%;
        }
    }
    @media (min-width: 325px) {
        .modal_terms_buttons {
            margin: auto;
            width: 90%;
            height: 100%;
            font-size: 150%;
            letter-spacing: 1px;
            background-color: #2B2D42;
            margin: 5%;
        }
    }
    #createDesktop {
        background: #2B2D42 0% 0% no-repeat padding-box;
        border-radius: 32px;
        color: white;
        border: none;
        letter-spacing: 0.85px;
        margin-left: 20px;
    }
</style>
